import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ReferenceLine, ResponsiveContainer, Legend
} from 'recharts'

const BOYA_CHARTS = [
  { key: 'furnace_zone1_temp', label: 'Fırın Zone 1 (°C)', threshold: 235, color: '#f97316' },
  { key: 'furnace_zone2_temp', label: 'Fırın Zone 2 (°C)', threshold: 255, color: '#fb923c' },
  { key: 'vibration_rms',     label: 'Titreşim (mm/s)',   threshold: 4.5, color: '#a78bfa' },
  { key: 'bearing_temp',      label: 'Rulman Sıcaklığı (°C)', threshold: 70, color: '#f43f5e' },
  { key: 'band_tension',      label: 'Bant Gerilimi (N/mm²)', threshold: 14, color: '#34d399' },
  { key: 'pump_pressure',     label: 'Pompa Basıncı (bar)',   threshold: 2.5, color: '#60a5fa' },
]

const ALKALI_CHARTS = [
  { key: 'bath_conductivity', label: 'Banyo İletkenliği (mS/cm)', threshold: 110, color: '#f97316' },
  { key: 'bath_temp',         label: 'Banyo Sıcaklığı (°C)',      threshold: 82,  color: '#fb923c' },
  { key: 'ph',                label: 'pH',                         threshold: 10.5, color: '#34d399' },
  { key: 'brush_current',     label: 'Fırça Akımı (A)',           threshold: 17,  color: '#a78bfa' },
  { key: 'vibration_rms',     label: 'Titreşim (mm/s)',           threshold: 4.0, color: '#f43f5e' },
]

const TANDEM_CHARTS = [
  { key: 'rolling_force',     label: 'Hadde Kuvveti (kN)',        threshold: 10000, color: '#f97316' },
  { key: 'motor_torque',      label: 'Motor Torku (kNm)',         threshold: 160,   color: '#a78bfa' },
  { key: 'motor_current',     label: 'Motor Akımı (A)',           threshold: 360,   color: '#f43f5e' },
  { key: 'vibration_rms',     label: 'Titreşim (mm/s)',           threshold: 5.0,   color: '#60a5fa' },
  { key: 'emulsion_pressure', label: 'Emülsiyon Basıncı (bar)',   threshold: 9,     color: '#34d399' },
]

function getCharts(hatType) {
  if (hatType === 'BOYA')   return BOYA_CHARTS
  if (hatType === 'ALKALI') return ALKALI_CHARTS
  if (hatType === 'TANDEM') return TANDEM_CHARTS
  return []
}

export default function SensorChart({ data, hatType }) {
  if (!data || data.length === 0) {
    return <div className="text-slate-500 text-center py-8">Veri yükleniyor...</div>
  }

  const charts = getCharts(hatType)

  const formatted = [...data].reverse().map((row, i) => ({
    ...row,
    time: new Date(row.timestamp).toLocaleTimeString('tr-TR', {
      hour: '2-digit', minute: '2-digit'
    }),
    index: i
  }))

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {charts.map((chart) => (
        <div key={chart.key} className="bg-slate-800/50 rounded-xl p-4">
          <h4 className="text-sm font-medium text-slate-300 mb-3">{chart.label}</h4>
          <ResponsiveContainer width="100%" height={180}>
            <LineChart data={formatted}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
              <XAxis
                dataKey="time"
                tick={{ fontSize: 10, fill: '#94a3b8' }}
                interval="preserveStartEnd"
              />
              <YAxis tick={{ fontSize: 10, fill: '#94a3b8' }} />
              <Tooltip
                contentStyle={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8 }}
                labelStyle={{ color: '#94a3b8' }}
              />
              <ReferenceLine
                y={chart.threshold}
                stroke="#ef4444"
                strokeDasharray="4 4"
                label={{ value: 'Eşik', fill: '#ef4444', fontSize: 10 }}
              />
              <Line
                type="monotone"
                dataKey={chart.key}
                stroke={chart.color}
                dot={false}
                strokeWidth={2}
                connectNulls={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ))}
    </div>
  )
}